import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../shared/source/context/context';
import { globalOptionsSchema } from '../../data-contract/global-search';

import type { Pathname } from '../../../../shared/source/http-fetcher/http-fetcher';
import type { GlobalPermissions } from '../../data-contract/global-search';
import type { UseQueryResult } from '@tanstack/react-query';

export const useGlobalPermissions = (): UseQueryResult<GlobalPermissions, Error> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = '/global/options';

    return useQuery({
        // eslint-disable-next-line complexity
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(globalOptionsSchema, {
                pathname,
            });

            if (result.isOk) {
                const data = result.value;

                return {
                    ...data,
                    canUserSearch:
                        data.canSearchUsers ||
                        data.canSearchLearningOpportunities ||
                        data.canSearchJobs ||
                        data.canSearchSkills,
                    canUserTalentDirectory:
                        data.canDirectoryUsers ||
                        data.canDirectoryLearningOpportunities ||
                        data.canDirectoryJobs ||
                        data.canDirectorySkills,
                };
            }

            throw result.error;
        },
        queryKey: [pathname, 'GET'],
        refetchOnMount: false,
    });
};
